<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-image"
    :submitting="submitting"
    submitTitle="Update"
    :submitDisabled="!hasImage"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="imageForm" :labelColumnSize="3">
      <input ref="imageFile" type="file" name="image" accept="image/*" @change="setImage" style="display: none" />
      <div style="width: 100%; height:300px; border: 1px solid #efefef; display: inline-block;" @click="cropperAreaClicked" :class="[circleCrop ? 'logo-circle-cropper' : '']">
        <vue-cropper
          ref="cropper"
          :guides="true"
          :view-mode="0"
          drag-mode="crop"
          :auto-crop-area="0.5"
          :min-container-width="250"
          :min-container-height="180"
          :background="false"
          :rotatable="false"
          :aspectRatio="1"
          :src="imgSrc"
          v-show="imgSrc"
          alt=" "
          :img-style="{ 'width': '100%', 'height': '300px', 'color': 'transparent' }">
        </vue-cropper>
      </div>
      <div class="mt-1">
        <a class="btn btn-white" @click.prevent="$refs.imageFile.click()"><i class="far fa-upload"> </i> Import Image</a>&nbsp;
        <a class="btn btn-white" v-show="false" @click.prevent="cropperReset()"><i class="far fa-sync"> </i> Reset</a>&nbsp;
        <a class="btn btn-white" v-show="false" @click.prevent="cropperZoomIn()"><i class="far fa-search-plus"> </i> </a>
        <a class="btn btn-white" v-show="false" @click.prevent="cropperZoomOut()"><i class="far fa-search-minus"> </i> </a>&nbsp;
      </div>
    </FormGroup>
  </ModalDialog>
</template>

<style>
.logo-circle-cropper .cropper-view-box, .logo-circle-cropper .cropper-face {
  border-radius: 50%;
}
</style>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: "EditLogoImageDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    VueCropper
  },
  props: {
    APIresource: String,
    title: {
      type: String,
      default: 'Edit Logo'
    },
    logoTypeName: {
      type: String,
      default: 'logo'
    },
    resourceId: {
      type: [Number, String],
      default: null
    },
    currentURL: String,
    circleCrop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgSrc: '',
      image: {
      },
      imageForm: {},
      submitting: false,
    }
  },
  mounted() {
    
  },
  computed: {
    hasImage() {
      return this.imgSrc
    }
  },
  methods: {
    show() {
      // Reset form
      this.image = {}
      this.imageForm = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var croppedCanvas = this.$refs.cropper.getCroppedCanvas({
        minWidth: 16,
        minHeight: 16,
        maxWidth: 512,
        maxHeight: 512,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      });

      // Upload cropped image
      var imageData = croppedCanvas.toDataURL()

      this.$apiService.coreService.updateLogoImage(this.resourceId, this.APIresource, this.logoTypeName, { image: imageData })
      .then(() => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.imageForm = this.processFormResponse(err)
      })
    },
    cropperAreaClicked() {
      if(!this.imgSrc) {
        this.$refs.imageFile.click()
      }
    },
    cropperReset() {
    },
    cropperZoomIn() {
    },
    cropperZoomOut() {
    },
    setImage(e) {
      const file = e.target.files[0];
      if(file == null)
        return

      if (!file.type.includes('image/')) {
        this.errorMessage('Error', 'Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        };
        reader.readAsDataURL(file)
      } else {
        this.errorMessage('Error', 'Sorry, FileReader API not supported. Please update your browser or use Chrome/Firefox/Safari');
      }
    },
  }
}
</script>